import React, { useState } from "react";

// Typed date of birth field: the user types DD/MM/YYYY in one go (slashes are
// added automatically). The parent receives an ISO date (YYYY-MM-DD) through
// onChange({ target: { name, value } }), or "" while the date is incomplete.

const MIN_AGE = 18;

const formatDigits = (digits) => {
  const d = digits.slice(0, 8);
  if (d.length <= 2) return d;
  if (d.length <= 4) return `${d.slice(0, 2)}/${d.slice(2)}`;
  return `${d.slice(0, 2)}/${d.slice(2, 4)}/${d.slice(4)}`;
};

const toIsoDate = (text) => {
  const match = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(text);
  if (!match) return null;
  const [, dd, mm, yyyy] = match;
  const date = new Date(Number(yyyy), Number(mm) - 1, Number(dd));
  const isRealDate =
    date.getFullYear() === Number(yyyy) &&
    date.getMonth() === Number(mm) - 1 &&
    date.getDate() === Number(dd);
  return isRealDate ? { iso: `${yyyy}-${mm}-${dd}`, date } : null;
};

const ageOn = (birthDate, today = new Date()) => {
  let age = today.getFullYear() - birthDate.getFullYear();
  const beforeBirthday =
    today.getMonth() < birthDate.getMonth() ||
    (today.getMonth() === birthDate.getMonth() && today.getDate() < birthDate.getDate());
  return beforeBirthday ? age - 1 : age;
};

const DateOfBirthInput = ({ id = "date_of_birth", name = "date_of_birth", onChange, className, hasError }) => {
  const [text, setText] = useState("");
  const [localError, setLocalError] = useState("");

  const emit = (value) => onChange({ target: { name, value } });

  const handleChange = (e) => {
    const formatted = formatDigits(e.target.value.replace(/\D/g, ""));
    setText(formatted);
    setLocalError("");

    if (formatted.length < 10) {
      emit("");
      return;
    }

    const parsed = toIsoDate(formatted);
    if (!parsed) {
      setLocalError("Please enter a valid date (DD/MM/YYYY)");
      emit("");
    } else if (ageOn(parsed.date) < MIN_AGE) {
      setLocalError(`You must be at least ${MIN_AGE} years old to register`);
      emit("");
    } else if (parsed.date.getFullYear() < 1900) {
      setLocalError("Please enter a valid year");
      emit("");
    } else {
      emit(parsed.iso);
    }
  };

  return (
    <>
      <input
        type="text"
        inputMode="numeric"
        autoComplete="bday"
        id={id}
        name={name}
        value={text}
        onChange={handleChange}
        placeholder="DD/MM/YYYY"
        maxLength={10}
        className={className}
        aria-invalid={Boolean(localError || hasError)}
        required
      />
      {localError && (
        <p className="mt-1 text-[11px] text-red-600">{localError}</p>
      )}
    </>
  );
};

export default DateOfBirthInput;
